import { Dialog, DialogOverlay } from "@/components/ui/dialog";
import { type FC } from "react";
import SignUp from "./SignUp";
import SignIn from "./SignIn";
import { useLocation } from "react-router";
import ResetPassword from "./ResetPassword";
import SignUpOTP from "./SignUpOTP";

type Props = {
  open?: boolean;
};

const AuthWrap: FC<Props> = ({ open }) => {
  const { pathname } = useLocation();

  return (
    <Dialog open={open === undefined ? true : open}>
      <DialogOverlay
        style={{
          WebkitMaskImage:
            "linear-gradient(to bottom, rgba(255, 255, 255, 0.6) 35%, rgba(255, 255, 255, 1) 65%)",
          maskImage:
            "linear-gradient(to bottom, rgba(255, 255, 255, 0.6)%, rgba(255, 255, 255, 1))",
        }}
        className="backdrop-blur-[10px]"
      />
      {pathname.includes("/sign-in") && <SignIn />}
      {pathname.includes("/sign-up") && <SignUp />}
      {pathname.includes("/reset-password") && <ResetPassword />}
      {pathname.includes("/confirm") && <SignUpOTP />}
    </Dialog>
  );
};

export default AuthWrap;
